import axios from 'axios';
import router from '../router'
import { Message } from 'element-ui';
// 创建axios实例
const service = axios.create({
  // baseURL: 'https://kaoguo-api.bankaoedu.com/api/v2/',
  timeout: 500000 // 请求超时时间
});
 
// 请求拦截器
service.interceptors.request.use(
  
  config => {
    // 可以在这里添加请求头等信息
    // if (store.getters.token) {
    //   config.headers['X-Token'] = getToken();
    // }
    if(config.url && config.url.indexOf('resume/upload') != -1){
      config.headers['Content-Type'] = 'multipart/form-data'
    }else{
      config.headers['Content-Type'] = 'application/json'
    }
    config.headers['platform'] = "PC"
    config.headers['Authorization'] = 'Bearer ' +  localStorage.getItem('token')
    return config;
  },
  error => {
    Message.error('服务错误，请联系管理员！')
    // 请求错误处理
    Promise.reject(error);
    
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做处理，例如只返回data部分
    const res = response.data;
    let { code,message } = res
    if(code == 401){
      Message.error('登录失效，请重新登录')
      setTimeout(() => {
        console.log(router,'router')
        localStorage.removeItem('token')
        router.replace('/login?redirect=' + router.app._route.fullPath)
      },1000)
    }else if(code != 0){
      Message.error(message)
    }
    return response.data;
  },
  error => {
    Message.error('服务错误，请联系管理员！')
    return Promise.reject(error);
  }
);
 
export default service;